import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  #boundHandleClickOutside = null

  connect() {
    this.#boundHandleClickOutside = this.#handleClickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.#boundHandleClickOutside)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.#open()
    } else {
      this.#close()
    }
  }

  #open() {
    this.menuTarget.classList.remove("hidden")
    document.addEventListener("click", this.#boundHandleClickOutside)
  }

  #close() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.#boundHandleClickOutside)
  }

  #handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.#close()
    }
  }
}
